import { getTaskImage } from '@/features/single-measurement/services/tasks';
import { IBatch } from '@/features/single-measurement/types';

export const getBatchImages = async (batch: IBatch) => {
  const batchId = batch.id;
  const images = [];
  for (const { id: taskId } of batch.tasks) {
    for (const imageType of ['source', 'result']) {
      const image = await getTaskImage({ taskId, batchId, imageType });
      images.push({ taskId, batchId, imageType, image });
    }
  }
  return images;
};
